import { memo } from "react";

import type { RequestFilterType } from "../../../types/filters";

import { queuedTableConfig } from "../../../config/tables/superadmin/queuedTableConfig";
import { UnifiedSuperAdminTab } from "./UnifiedSuperAdminTab";

interface QueuedTabProps {
  lazyLoadingConfig?: {
    currentTab: string;
    enabled: boolean;
  };
  searchValue?: string;
  selectedFilter?: RequestFilterType;
}

function QueuedTabComponent(props: QueuedTabProps) {
  return (
    <UnifiedSuperAdminTab
      {...props}
      tableConfig={queuedTableConfig}
      tabType="queued"
    />
  );
}

export const QueuedTab = memo(QueuedTabComponent);
